import { Component, OnInit, inject } from '@angular/core';
import { CommonService } from '../../common.service';

@Component({
  selector: 'app-privacy',
  templateUrl: './privacy.html',
  styleUrl: './privacy.scss',
})
export class Privacy implements OnInit {
  private readonly commonService = inject(CommonService);

  ngOnInit(): void {
    this.commonService.showTitle('/assets/titles/privacy.jpg');
  }
}
